'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NEW_LINK_ID = exports.NEW_LINK_ID = 'new';

var MEETINGS_APP_NAME = exports.MEETINGS_APP_NAME = 'meetings';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/constants/strings.js
// module id = 424
// module chunks = 0